// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.yourLoanOfficer_loanOfficerCardContent__naSDL {
    align-self: center;
    display: flex;
    margin-bottom: 8px;
    width: 256px;
    max-width: 100%;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.yourLoanOfficer_yourLoanOfficer__78JHB {
    justify-content: left;
    display: flex;
    text-align: left;
    color: var(--half-secondary, #516F91);
    font-family:
        Lato, sans-serif;
    font-size: inherit;
    font-weight: 700;
    align-self: start;
    margin-top: 9px
}

.yourLoanOfficer_loanOfficerInfo__J8YUn {
    justify-content: left;
    text-align: left;
    display: flex;
    color: var(--half-secondary, #516F91);
    font-family:
        Lato, sans-serif;
    font-size: 60%;
    font-weight: 700;
    align-self: start;
    margin-top: 9px
}

.yourLoanOfficer_homeLogo__Ci-1x {
    justify-content: center;
    aspect-ratio: 1.05;
    object-fit: cover;
    object-position: center;
    width: 138px;
    overflow: hidden;
    margin-top: -11px;
    @media (max-width: 991px) {
        margin-left: 10px,
    }
}

.yourLoanOfficer_callAndEmail__5jjZS{
    align-self: center;
    display: flex;
    width: 291 px;
    max-width: 100%;
    align-items: flex-start;
    justify-content: space-between;
    gap: 20 px;
}

.yourLoanOfficer_callAndEmailButton__o3F0u{
    border-radius: 20px;
    background-color: #3E94A3;
    display: flex;
    flex-direction: column;
    flex: 1 1;
    padding: 13px 20px;
    width: 100px;
    margin-right: 20px;
}

.yourLoanOfficer_call__kdxvy{
    color: #FFF;
    text-align: center;
    font-family: Poppins, sans-serif;
    font-size: 13px;
    font-weight: 13px;
    line-height: 130%;
    align-self: center;
    text-wrap: nowrap;
    @media (max-width: 991px) {
        text-wrap: initial;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/yourLoanOfficer.module.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,aAAa;IACb,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,aAAa;IACb,gBAAgB;IAChB,qCAAqC;IACrC;wBACoB;IACpB,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB;AACJ;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,aAAa;IACb,qCAAqC;IACrC;wBACoB;IACpB,cAAc;IACd,gBAAgB;IAChB,iBAAiB;IACjB;AACJ;;AAEA;IACI,uBAAuB;IACvB,kBAAkB;IAClB,iBAAiB;IACjB,uBAAuB;IACvB,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;IACjB;QACI;IACJ;AACJ;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,aAAa;IACb,eAAe;IACf,uBAAuB;IACvB,8BAA8B;IAC9B,UAAU;AACd;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,aAAa;IACb,sBAAsB;IACtB,SAAO;IACP,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,gCAAgC;IAChC,eAAe;IACf,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;IACjB;QACI,kBAAkB;IACtB;AACJ","sourcesContent":[".loanOfficerCardContent {\n    align-self: center;\n    display: flex;\n    margin-bottom: 8px;\n    width: 256px;\n    max-width: 100%;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n}\n\n.yourLoanOfficer {\n    justify-content: left;\n    display: flex;\n    text-align: left;\n    color: var(--half-secondary, #516F91);\n    font-family:\n        Lato, sans-serif;\n    font-size: inherit;\n    font-weight: 700;\n    align-self: start;\n    margin-top: 9px\n}\n\n.loanOfficerInfo {\n    justify-content: left;\n    text-align: left;\n    display: flex;\n    color: var(--half-secondary, #516F91);\n    font-family:\n        Lato, sans-serif;\n    font-size: 60%;\n    font-weight: 700;\n    align-self: start;\n    margin-top: 9px\n}\n\n.homeLogo {\n    justify-content: center;\n    aspect-ratio: 1.05;\n    object-fit: cover;\n    object-position: center;\n    width: 138px;\n    overflow: hidden;\n    margin-top: -11px;\n    @media (max-width: 991px) {\n        margin-left: 10px,\n    }\n}\n\n.callAndEmail{\n    align-self: center;\n    display: flex;\n    width: 291 px;\n    max-width: 100%;\n    align-items: flex-start;\n    justify-content: space-between;\n    gap: 20 px;\n}\n\n.callAndEmailButton{\n    border-radius: 20px;\n    background-color: #3E94A3;\n    display: flex;\n    flex-direction: column;\n    flex: 1;\n    padding: 13px 20px;\n    width: 100px;\n    margin-right: 20px;\n}\n\n.call{\n    color: #FFF;\n    text-align: center;\n    font-family: Poppins, sans-serif;\n    font-size: 13px;\n    font-weight: 13px;\n    line-height: 130%;\n    align-self: center;\n    text-wrap: nowrap;\n    @media (max-width: 991px) {\n        text-wrap: initial;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"loanOfficerCardContent": `yourLoanOfficer_loanOfficerCardContent__naSDL`,
	"yourLoanOfficer": `yourLoanOfficer_yourLoanOfficer__78JHB`,
	"loanOfficerInfo": `yourLoanOfficer_loanOfficerInfo__J8YUn`,
	"homeLogo": `yourLoanOfficer_homeLogo__Ci-1x`,
	"callAndEmail": `yourLoanOfficer_callAndEmail__5jjZS`,
	"callAndEmailButton": `yourLoanOfficer_callAndEmailButton__o3F0u`,
	"call": `yourLoanOfficer_call__kdxvy`
};
export default ___CSS_LOADER_EXPORT___;
